import type { Action } from "@/types";
import {
  SET_KOTS_APP_LIST,
  SET_KOTS_APP_SECURITY_CENTER_ENABLED
} from "./actions";

const initialState = {
  kotsApps: [],
  // Tells a fetched empty list apart from the empty list before the first fetch.
  kotsAppsFetched: false,
  securityCenterUpdateSequences: {}
};

export default function (state = initialState, action: Action = {}) {
  switch (action.type) {
    case SET_KOTS_APP_LIST: {
      const kotsApps = action.payload.kotsApps.apps ?? [];
      const currentAppsById = new Map(
        state.kotsApps.map(app => [app.id, app])
      );
      const securityCenterUpdateSequences =
        state.securityCenterUpdateSequences ?? {};
      const requestSequence = action.payload.requestSequence;

      return {
        ...state,
        kotsAppsFetched: true,
        kotsApps: kotsApps.map(app => {
          const securityCenterUpdateSequence =
            securityCenterUpdateSequences[app.id];
          const currentApp = currentAppsById.get(app.id);

          // Merge every field from the response, but preserve the targeted
          // Security Center update when this request started before it.
          if (
            currentApp &&
            typeof requestSequence === "number" &&
            typeof securityCenterUpdateSequence === "number" &&
            requestSequence < securityCenterUpdateSequence
          ) {
            return {
              ...app,
              securityCenterEnabled: currentApp.securityCenterEnabled
            };
          }

          return app;
        })
      };
    }
    case SET_KOTS_APP_SECURITY_CENTER_ENABLED:
      return {
        ...state,
        securityCenterUpdateSequences: {
          ...(state.securityCenterUpdateSequences ?? {}),
          [action.payload.appId]: action.payload.updateSequence
        },
        kotsApps: state.kotsApps.map(app =>
          app.id === action.payload.appId
            ? {
                ...app,
                securityCenterEnabled: action.payload.enabled
              }
            : app
        )
      };
    default:
      return state;
  }
}
